<div
  class="podcast_wrapper container"
  [style.padding]="storybook ? '2rem' : '0'"
  [id]="id"
>
  <h3 *ngIf="title">{{ title }}</h3>
  <div
    class="podcast_link-box"
    [ngClass]="{ 'podcast_link-box--no-headline': !linkHeadline }"
    *ngIf="linkHeadline || link"
  >
    <h4
      class="podcast_link-box-headline"
      *ngIf="linkHeadline"
      [innerHTML]="linkHeadline.trim()"
    ></h4>
    <hdi-link
      class="podcast_link-box-link"
      *ngIf="link"
      [label]="link.label | capitalize"
      [href]="link.href!"
      [title]="link.title ?? ''"
      [hrefType]="link.hrefType!"
      [type]="LinkType.PRIMARY_ARROW"
      [target]="'_self'"
    ></hdi-link>
  </div>
  <div
    class="podcast"
    *ngFor="let podcastItem of PodcastItems; let i = index"
    [ngClass]="{ active: isOpen[i] }"
    [id]="podcastItem.id"
    #podcastsRef
  >
    <hdi-image
      class="podcast_image"
      [src]="podcastItem.image"
      [alt]="getAltTextById(podcastItem.imageIdentifier)"
      [title]="podcastItem.imageTitle"
    ></hdi-image>
    <div
      class="podcast_title"
      (click)="toggleOpenClose(i)"
      [id]="podcastItem.key"
    >
      <span class="podcast_subtitle"> {{ podcastItem.subline }}</span>

      {{ podcastItem.headline }}
    </div>
    <hdi-button
      class="podcast_btn"
      [ngClass]="{ 'podcast_btn--open': isOpen[i] }"
      [label]="headerLabel | capitalize"
      [type]="accordion"
      [isOpen]="isOpen[i]"
      [iconName]="isOpen[i] ? 'minus' : 'plus'"
      (click)="handleClick(i)"
      [@rotateAnimation]="animationStates[i]"
    >
    </hdi-button>

    <div [ngClass]="{ active: isOpen[i] }" class="podcast_content">
      <div
        class="podcast_content-text"
        *ngIf="podcastItem.content"
        [innerHTML]="podcastItem.content"
      ></div>
      <div
        class="podcast_player_wrapper"
        [innerHTML]="safeIframe ? safeIframe : podcastItem.safeIframe"
      >
        <!-- <iframe
          [src]="currentIframe"
          frameborder="0"
          [title]="podcastItem.title"
          allow="autoplay"
          class="podcast_player"
        ></iframe> -->
      </div>
    </div>
  </div>
  <div class="podcast_more-less-wrapper">
    <hdi-button
      *ngIf="isPodcastHub"
      [type]="moreLessType"
      [label]="isUnrolledLabel | capitalize"
      [iconName]="isUnrolledIcon"
      (click)="showMoreLess()"
    ></hdi-button>
  </div>
</div>
